import { ActionExtended } from "src/_common/interfaces/ActionExtended";
import { ACTIONS, STORAGE } from "src/_config";
import { JobCandidatesResponse } from "src/_common/interfaces/ApiReqRes";

export interface JobReducer {
  jobs: any[];
  jobCandidates: JobCandidatesResponse | null;
  candidateDetails: any | null;
  screeningData: any | null;
}

const initialState: JobReducer = {
  jobs: [],
  jobCandidates: null,
  candidateDetails: null,
  screeningData: null,
};

const jobReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.JOB.GET_EMPLOYER_JOBS:
      return {
        ...state,
        jobs: action.payload,
      };

    case ACTIONS.JOB.GET_JOB_CANDIDATES:
      return {
        ...state,
        jobCandidates: action.payload,
      };

    case ACTIONS.JOB.GET_CANDIDATE_DETAILS:
      return {
        ...state,
        candidateDetails: action.payload,
      };

    case ACTIONS.JOB.GET_SCREENING:
      return {
        ...state,
        screeningData: action.payload,
      };

    case ACTIONS.USER.LOGIN:
    case ACTIONS.USER.LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
};

export default jobReducer;
